export let stripeApiKey;

if (import.meta.env.VITE_APP_API_ENV === 'production') {
  stripeApiKey = 'pk_live_VmSSqKxk5PJLzh7LZIAHtqQf00m1C00fiC';
} else {
  stripeApiKey = 'pk_test_uLML7YKdjeNicJxs2r2LQ9WD00Owi1NKnB';
}
